export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/asciiEncoder.worker.24e125f1.worker.js");
}
